import { useContext } from 'react';
import { PlaycastContext } from '../../Playcast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGearComplex } from '@fortawesome/pro-solid-svg-icons';
import { store } from '../store';

export const OptionsToggle = () => {
  const data = useContext(PlaycastContext);

  const toggleOptions = () => {
    store.updatePlayerOptionsOpen(!data.options.open);
  };

  // Only show in spectator mode
  if (data.mode.mode === 'player') return null;

  return (
    <div className='absolute top-4 right-4 z-100 flex space-x-4 cursor-pointer'>
      <FontAwesomeIcon icon={faGearComplex} className='text-amber-400 opacity-50' size='lg' onClick={toggleOptions} />
    </div>
  );
};
